// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#footer_area[data-v-3d302860] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #363b48;\n  color: white;\n  font-weight: bold;\n  z-index: 12;\n}\n#middle_divider[data-v-3d302860] {\n  background-color: #fff;\n}\n\n/* @media ( max-width: 768px ) {\n  #footer_area {\n    display: none;\n  }\n} */", ""]);
// Exports
module.exports = exports;
